import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import StackView from '../StackView';

function PageActions(props) {
  return /*#__PURE__*/React.createElement(StackView, _extends({
    alignment: "center",
    alignSelf: "end",
    axis: "horizontal",
    distribution: "end",
    flex: "1",
    paddingBottom: 2,
    spacing: 1
  }, props));
}

export default PageActions;